import { useContext, useState } from "react";
import { AuthContext } from "../../../../../auth-context";
import Modal from "../../../../../components/modal";
import Input from "../../../../../components/input";
import { ErrorMessage } from '../../../../../components/error-message'
import { importPortalSurvey } from "../../../../../api";

export const ImportSurveyModal = ({ open, onClose, fetchSurveys }) => {
  const { user } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [shareID, setShareID] = useState("");
  const [nameError, setNameError] = useState("");
  const [shareIDError, setShareIDError] = useState("");
  const [error, setError] = useState("");

  const clearErrors = () => {
    setNameError(false);
    setShareIDError(false);
    setError("");
  };

  const handleImport = async () => {
    clearErrors();
    if (name === "") {
      setNameError(true);
      setError("Please enter a name for the form.");
    } else if (shareID === "") {
      setShareIDError(true);
      setError("Please enter an ID to import the form from.");
    } else {
      importPortalSurvey(user.id, shareID, name).then((res) => {
        clearErrors();
        onClose();
        fetchSurveys();
      });
    }
  };

  return (
    <Modal
      title="Import Check-in Form"
      submitLabel="Import"
      handleSubmit={handleImport}
      open={open}
      onClose={onClose}
    >
      <div>
        <Input
          error={!!nameError}
          label="Name (for your copy of the check-in form)"
          value={name}
          onChange={setName}
        />

        <Input
          error={!!shareIDError}
          label="Check-in Form ID (ask the form creator for this)"
          value={shareID}
          onChange={setShareID}
        />

        {error !== "" && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    </Modal>
  );
};
